import React from 'react';
import PropTypes from 'prop-types';

/**
 * WorkflowSelector - Compact workflow mode selector
 * Simplified design to reduce visual clutter
 */
function WorkflowSelector({ selectedWorkflow, onSelectWorkflow, disabled = false }) {
  const workflows = [
    { id: 'simple', name: 'Simple', description: 'Schnell & einfach' },
    { id: 'chunked', name: 'Chunked', description: 'Seiten splitten', disabled: true },
    { id: 'editor', name: 'Editor', description: 'Volle Kontrolle', disabled: true }
  ];

  return (
    <div className="flex items-center gap-2 bg-white dark:bg-gray-800 rounded-lg p-1 border border-gray-200 dark:border-gray-700">
      <span className="text-xs text-gray-500 dark:text-gray-400 px-2 hidden sm:inline">Modus:</span>
      {workflows.map((workflow) => {
        const isSelected = selectedWorkflow === workflow.id;
        const isDisabled = disabled || workflow.disabled;
        
        return (
          <button
            key={workflow.id}
            onClick={() => !isDisabled && onSelectWorkflow(workflow.id)}
            disabled={isDisabled}
            title={workflow.disabled ? 'Kommt bald' : workflow.description}
            className={`
              flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all
              ${isSelected 
                ? 'bg-primary-600 text-white' 
                : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
              }
              ${isDisabled && !isSelected ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            <span>{workflow.name}</span>
          </button>
        );
      })}
    </div>
  );
}

WorkflowSelector.propTypes = {
  selectedWorkflow: PropTypes.oneOf(['simple', 'chunked', 'editor']).isRequired,
  onSelectWorkflow: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default WorkflowSelector;
